module.exports = __webpack_public_path__ + "img/logo-small-dark.f4099730.svg";